import { render, staticRenderFns } from "./houseModel.vue?vue&type=template&id=5ff43108&"
import script from "./houseModel.vue?vue&type=script&lang=js&"
export * from "./houseModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\TeamCity\\buildAgent\\work\\d66fd695757ba5a4\\src\\SABONyproduktion.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5ff43108', component.options)
    } else {
      api.reload('5ff43108', component.options)
    }
    module.hot.accept("./houseModel.vue?vue&type=template&id=5ff43108&", function () {
      api.rerender('5ff43108', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/vue/houseModel/houseModel.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./assets/vue/houseModel/houseModel.vue
// module id = 475
// module chunks = 0